export default __webpack_public_path__ + "static/media/fndisplay.f3ef3fa5.png";